/**
 * Created by Angelika on 30.08.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import StalkerApiManager from '../api/StalkerApiLoaderManager';
import {onError} from './index';

let api = StalkerApiManager.getInstance();
let loader = api.getLoader();

export function getGenres() {
    return dispatch => {
        dispatch({type: actionTypes.GET_GENRES_REQUEST});
        return loader.getGenres().then(
            data => dispatch({type: actionTypes.GET_GENRES_SUCCESS, genres: data}),
            error => dispatch(onError(error, actionTypes.GET_GENRES_FAILED))
        )
    }
}

export function selectGenre(genre) {
    return dispatch => {
        dispatch({type: actionTypes.SET_GENRE_FILTER, genre: genre});
        dispatch({type: actionTypes.SHOW_CHANNEL_FRAME});
    }
}

export function resetGenreFilter() {
    return {type: actionTypes.RESET_GENRE_FILTER};
}


// WEBPACK FOOTER //
// ./src/actions/genres.js